import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { apiClient } from "../../lib/api";
import { useUpdateProject } from "../../hooks/useProjects";
import { errorMessage } from "../../hooks/useServers";

// «Instrucciones del agente»: el prompt especial del agente general (su personalidad y sus reglas). Se aplica desde el siguiente mensaje.
export function GeneralPromptDialog({ open, onOpenChange, project }) {
  const projectId = project?.id;
  const { data, isLoading, isError } = useQuery({
    queryKey: ["project-detail", projectId],
    queryFn: async () => (await apiClient.get(`/projects/${projectId}`)).data,
    enabled: open && !!projectId,
    staleTime: 0,
  });
  const update = useUpdateProject();
  const [text, setText] = useState("");
  const [error, setError] = useState("");
  useEffect(() => { if (open && data) setText(data.system_prompt || ""); }, [open, data]);
  const changed = !!data && text.trim() !== (data.system_prompt || "").trim();
  const save = async () => {
    setError("");
    try {
      await update.mutateAsync({ id: projectId, system_prompt: text.trim() });
      onOpenChange(false);
    } catch (e) {
      setError(errorMessage(e, "No se pudo guardar."));
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="general-prompt-dialog" className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Instrucciones del agente</DialogTitle>
          <DialogDescription>Cómo quieres que sea y que trabaje el Orquestador general. Se aplica desde tu siguiente mensaje.</DialogDescription>
        </DialogHeader>
        {isLoading && <p data-testid="general-prompt-loading" className="text-sm text-muted-foreground">Cargando…</p>}
        {isError && <p data-testid="general-prompt-load-error" className="text-sm text-amber-500">No se pudieron leer las instrucciones.</p>}
        {data && (
          <Textarea data-testid="general-prompt-text" rows={14} value={text} onChange={(e) => setText(e.target.value)} className="font-mono text-xs" />
        )}
        {error && <p data-testid="general-prompt-error" className="text-sm text-amber-500">{error}</p>}
        <DialogFooter>
          <Button data-testid="general-prompt-cancel" variant="outline" size="sm" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button data-testid="general-prompt-save" size="sm" disabled={!changed || !text.trim() || update.isPending} onClick={save}>Guardar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
